import * as S from "./style";

/**
 * Components
 */
import CreateUser from "../../../components/Modals/User/Create";
import ActionButton from "../../Button/ActionButton";
import InputSearch from "../../FieldSearch";
/**
 * Hooks
 */
import { useMultipleModal } from "../../../hooks/useMultipleModal";

interface ITitle {
  title: string;
  subtitle: string;
  placeholderSearch: string;
  fetchData: () => void;
  titleButton: string;
  modalKey: string;
  filterSearch: (search: string) => void;
}

export default function TitleDefault({
  title,
  subtitle,
  placeholderSearch,
  fetchData,
  titleButton,
  modalKey,
  filterSearch,
}: ITitle) {
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />

        <ActionButton
          name={titleButton}
          onClick={() => toggleModalVisibility(modalKey)}
        />
      </S.ContentSearch>

      <CreateUser
        isOpenModal={isOpenModal("user")}
        setModalClose={() => toggleModalVisibility("user")}
        refreshFrames={fetchData}
      />

    </S.Container>
  );
}
